import React, { useState, useEffect, useRef } from "react";
import "./App.css";
import Header from "./Header";
import GlitchText from "./GlitchText";
import Aurora from "./Aurora";
import FooterMarquee from "./FooterMarquee";

// ================== Newsletter Component ==================
const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(""); // sending, success, error

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("sending");

    try {
      const response = await fetch("https://formspree.io/f/mkoqnpll", { // Replace with your Formspree ID
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setStatus("success");
        setEmail("");
      } else {
        setStatus("error");
      }
    } catch (err) {
      setStatus("error");
    }
  };

  // Auto-hide status after 10 seconds
  React.useEffect(() => {
    if (!status) return;

    const timer = setTimeout(() => {
      setStatus("");
    }, 10000); // 10000ms = 10 seconds

    return () => clearTimeout(timer);
  }, [status]);

  return (
    <div
      style={{
        position: "absolute",
        bottom: "25px",
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "10px",
        zIndex: 25,
        padding: "15px 25px",
        borderRadius: "10px",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        background: "rgba(0,0,0,0.5)",
        textAlign: "center",
      }}
    >
      {/* Heading */}
      <div
        style={{
          color: "#808080",
          fontSize: "16px",
          fontWeight: "bold",
          marginBottom: "8px",
        }}
      >
        Subscribe to our newsletter
      </div>

      {/* Input + Button */}
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", justifyContent: "center" }}>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{
            padding: "12px 18px",
            borderRadius: "8px",
            border: "none",
            outline: "none",
            fontSize: "14px",
            flex: 1,
            minWidth: "220px",
            background: "#1A1A1A",
            color: "#FFFFFF",
          }}
        />
        <button
          onClick={handleSubmit}
          style={{
            padding: "12px 25px",
            borderRadius: "8px",
            border: "none",
            cursor: "pointer",
            fontWeight: "bold",
            backgroundColor: "#080500ff",
            color: "#808080",
            fontSize: "14px",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#ffa6004d";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#080500ff";
          }}
        >
          Subscribe
        </button>
      </div>

      {/* Status Messages with Flicker */}
      <div style={{ marginTop: "5px", minHeight: "50px" }}>
        {status === "sending" && (
          <span style={{ color: "#ffa6004d", animation: "flicker 0.5s infinite alternate" }}>Sending…</span>
        )}
        {status === "success" && (
          <span style={{ color: "#ffa6004d", animation: "flicker 0.5s infinite alternate" }}>Sent successfully!</span>
        )}
        {status === "error" && (
          <span style={{ color: "#ffa6004d", animation: "flicker 0.5s infinite alternate" }}>Failed</span>
        )}

        {/* Flicker keyframes */}
        <style>
          {`
            @keyframes flicker {
              0% { opacity: 1; }
              25% { opacity: 0.4; }
              50% { opacity: 1; }
              75% { opacity: 0.6; }
              100% { opacity: 1; }
            }
          `}
        </style>
      </div>
    </div>

  );

};
// ================== Main App ==================
const App = () => {
  const [downloadChecked, setDownloadChecked] = useState(false);
  const [showLegal, setShowLegal] = useState(false);
  const [showAbout, setShowAbout] = useState(false);

  const audioRef = useRef(null);

  useEffect(() => {
    audioRef.current = new Audio("/simongarfunkel.mp3");
    audioRef.current.loop = true;
    audioRef.current.volume = 0.6;

    const tryPlay = () => {
      audioRef.current.play().catch(() => {});
      window.removeEventListener("click", tryPlay);
    };

    audioRef.current.play().catch(() => {
      window.addEventListener("click", tryPlay);
    });

    return () => window.removeEventListener("click", tryPlay);
  }, []);

  useEffect(() => {
    document.body.style.overflow = showLegal || showAbout ? "hidden" : "auto";
  }, [showLegal, showAbout]);

  return (
    <div
      style={{
        position: "relative",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "black",
      }}
    >
      <div style={{ position: "absolute", inset: 0, filter: "grayscale(100%)", zIndex: 0 }}>
        <Aurora />
      </div>

      <Header openLegal={() => setShowLegal(true)} openAbout={() => setShowAbout(true)} />

      {/* CENTER CONTENT */}
      <div
        style={{
          position: "absolute",
          top: "28%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 10,
          textAlign: "center",
        }}
      >
        <div className="glitch-hover-wrapper">
          <GlitchText speed={2}>IRONCLAD</GlitchText>
        </div>

        <div style={{ marginTop: "40px" }}>
          <input
            type="checkbox"
            id="download-check"
            style={{ display: "none" }}
            checked={downloadChecked}
            onChange={() => setDownloadChecked(!downloadChecked)}
          />
          <label
            htmlFor="download-check"
            style={{
              textTransform: "uppercase",
              border: "2px solid black",
              display: "inline-block",
              padding: downloadChecked ? "70px 200px" : "15px 50px",
              borderRadius: downloadChecked ? "0px" : "3px",
              cursor: "pointer",
              fontSize: "14px",
              transition: "all 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55)",
              background: "rgba(255,255,255,0.08)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              color: "#000000",
              fontWeight: "bold",
            }}
          >
            <a
              href="https://github.com/7Dinis/ironcladuploads/releases/download/ironclad/IroncladAV.exe"
              target="_blank"
              rel="noopener noreferrer"
              download="IroncladAV.exe"
              style={{ textDecoration: "none", color: "inherit" }}
              onClick={() => setDownloadChecked(true)}
            >
              {!downloadChecked ? "Download for Windows" : "✓ Download Started"}
            </a>
          </label>
        </div>

        <div style={{ marginTop: "20px" }}>
          <button
            onClick={() => setShowLegal(true)}
            style={{
              textTransform: "uppercase",
              border: "2px solid black",
              display: "inline-block",
              padding: "12px 40px",
              borderRadius: "3px",
              cursor: "pointer",
              fontSize: "13px",
              background: "rgba(255,255,255,0.08)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              color: "#000000",
              fontWeight: "bold",
            }}
          >
            Terms & Privacy
          </button>
        </div>
      </div>

      {/* Newsletter above footer */}
      <NewsletterForm />

      <FooterMarquee />

      {/* SOCIAL ICONS BOTTOM RIGHT */}
      <div
        style={{
          position: "absolute",
          bottom: "70px",
          right: "20px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          zIndex: 20,
        }}
      >
        <a href="https://www.instagram.com/ironcladtech/" target="_blank" rel="noopener noreferrer">
          <img src="/instagram.png" alt="Instagram" style={{ width: "35px", height: "35px" }} />
        </a>
        <a href="https://x.com/ironcladhelm/" target="_blank" rel="noopener noreferrer">
          <img src="/x.png" alt="X" style={{ width: "35px", height: "35px" }} />
        </a>
        <a href="https://www.youtube.com/@youtubecreators" target="_blank" rel="noopener noreferrer">
          <img src="/youtube.png" alt="YouTube" style={{ width: "35px", height: "35px", opacity: 0.5 }} />
        </a>
      </div>

      {/* MODAL WINDOW - TERMS & PRIVACY */}
      {showLegal && (
        <div className="modal-overlay" onClick={() => setShowLegal(false)}>
          <div className="modal-window" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={() => setShowLegal(false)}>✕</button>

            <div className="modal-scroll">
              <h1>IRONCLAD, LLC.</h1>
              <h2>TERMS OF SERVICE & PRIVACY POLICY</h2>
              <p><strong>Effective Date: February 2026</strong></p>

              <p>Welcome to Ironclad Antivirus, operated by Ironclad, Llc. (“Ironclad,” “we,” “us,” or “our”). By downloading, installing, accessing, or using Ironclad Antivirus, you agree to be bound by these Terms of Service and Privacy Policy. If you do not agree, you must discontinue use immediately.</p>

              <hr />

              <h3>PART I — TERMS OF SERVICE</h3>

              <h4>1. License Grant</h4>
              <p>Ironclad grants you a limited, non-exclusive, non-transferable, revocable license to install and use Ironclad Antivirus for personal or internal business security purposes.</p>

              <h4>2. Restrictions</h4>
              <p>You may not reverse engineer, decompile, modify, distribute, resell, or otherwise misuse the software, nor may you use it for unlawful purposes.</p>

              <h4>3. Updates</h4>
              <p>Ironclad Antivirus may automatically download updates, including threat definitions, security improvements, and performance enhancements.</p>

              <h4>4. No Guarantee of Detection</h4>
              <p>While Ironclad Antivirus is designed to enhance device security and reduce risk, no security solution can guarantee complete protection against all threats.</p>

              <h4>5. Disclaimer of Warranties</h4>
              <p>Ironclad Antivirus is provided on an “AS IS” and “AS AVAILABLE” basis, without warranties of any kind, whether express or implied.</p>

              <h4>6. Limitation of Liability</h4>
              <p>To the fullest extent permitted by applicable law, Ironclad shall not be responsible for any losses or damages arising out of or related to the use of, or inability to use, Ironclad Antivirus. In all cases, Ironclad’s total liability shall not exceed the amount paid for the software, if any. Use of Ironclad Antivirus is at your own discretion and risk.</p>

              <h4>7. Indemnification</h4>
              <p>You agree to indemnify and hold harmless Ironclad and its affiliates from any claims arising from your use of the software or violation of these Terms.</p>

              <h4>8. Termination</h4>
              <p>Ironclad reserves the right to suspend or terminate access if these Terms are violated.</p>

              <hr />

              <h3>PART II — PRIVACY POLICY</h3>

              <h4>1. Information We May Collect</h4>
              <p>Ironclad Antivirus may collect limited technical information necessary to provide and improve security services, such as software version details, basic device information, and security event data.</p>

              <h4>2. Purpose of Collection</h4>
              <p>Information is used solely to maintain, improve, and protect the integrity and performance of Ironclad Antivirus.</p>

              <h4>3. Data Practices</h4>
              <p>Ironclad does not sell personal information, track browsing activity for advertising purposes, or monetize user data.</p>

              <h4>4. Data Security</h4>
              <p>Ironclad implements reasonable administrative and technical safeguards designed to protect information. However, no system can guarantee absolute security.</p>

              <h4>5. Contact</h4>
              <p>For legal or privacy inquiries:<br/>ironcladco@proton.me</p>

              <hr />

              <p>By using Ironclad Antivirus, you acknowledge that you have read and agreed to these Terms and Privacy Policy.</p>
            </div>
          </div>
        </div>
      )}

      {/* MODAL WINDOW - ABOUT */}
      {showAbout && (
        <div className="modal-overlay" onClick={() => setShowAbout(false)}>
          <div className="modal-window" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={() => setShowAbout(false)}>✕</button>
            <div className="modal-scroll">
              <h1>ABOUT IRONCLAD</h1>
              <hr />
              <p>Ironclad is a cybersecurity and antivirus company dedicated to protecting businesses and individuals in an increasingly digital world. We provide advanced, proactive security solutions designed to prevent, detect, and respond to cyber threats before they impact your operations.</p>
              <p>Our team of experts combines deep industry knowledge with cutting edge technology to deliver comprehensive protection across all digital touchpoints. From ransomware and phishing attacks to sophisticated malware and network vulnerabilities, we provide solutions tailored to your unique needs.</p>
              <p>At Ironclad, security is more than a service, it’s a commitment. We prioritize reliability, innovation, and trust, ensuring that our clients can focus on growth and success with the confidence that their digital assets are safeguarded.</p>
              <p>For legal or privacy inquiries:<br/>ironcladco@proton.me</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default App;